import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthAction } from "./features/sign-in/AuthAction";
import { isAuthActionPath } from "./features/sign-in/authActionQuery";
import { queryClient } from "./lib/queryClient"; // module singleton (org-switch purge + logout reach it)

function Root() {
  // The reset link is a full page load. It must not wait on a restored session.
  if (isAuthActionPath()) return <AuthAction />;
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Root />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
